'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var compareAsc = require('date-fns/compareAsc');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var compareAsc__default = /*#__PURE__*/_interopDefault(compareAsc);

var Validator = function (value) {
    var error;
    var isEmpty = function (v) { return (v !== null && v !== void 0 ? v : null) === null || v === ''; };
    var evaluate = function (callback, evaluateWhenEmpty) {
        if (evaluateWhenEmpty === void 0) { evaluateWhenEmpty = false; }
        // don't evaluate if there's already an error
        // don't evaluate when value is empty unless evaluateWhenEmpty is true
        if (!error && (!isEmpty(value) || (isEmpty(value) && evaluateWhenEmpty))) {
            callback();
        }
    };
    var obj = {
        getError: function () {
            return error;
        },
        isValidFileType: function (errorMessage, fileTypes) {
            evaluate(function () {
                fileTypes.every(function (fileType) { return fileType !== value.slice(-fileType.length); })
                    ? (error = errorMessage)
                    : null;
            });
            return this;
        },
        required: function (errorMessage) {
            evaluate(function () {
                return (error =
                    !value || (typeof value === 'string' && !value.trim())
                        ? errorMessage
                        : null);
            }, true);
            return this;
        },
        minChar: function (errorMessage, minLength) {
            if (minLength === void 0) { minLength = 0; }
            evaluate(function () {
                var length = value && value.length ? value.length : 0;
                error = length < minLength ? errorMessage : null;
            });
            return this;
        },
        maxChar: function (errorMessage, maxLength) {
            evaluate(function () {
                var length = value && value.length ? value.length : 0;
                error = length > maxLength ? errorMessage : null;
            });
            return this;
        },
        maxBytes: function (errorMessage, maxLength) {
            evaluate(function () {
                var byteSize = new Blob([value]).size;
                error = byteSize > maxLength ? errorMessage : null;
            });
            return this;
        },
        isAlphaNumeric: function (errorMessage) {
            evaluate(function () {
                error = !value.match(/^[a-zA-Z0-9_]*$/) ? errorMessage : null;
            });
            return this;
        },
        isValidEmail: function (errorMessage) {
            var emailRegex = /^[a-zA-Z0-9!#$%&'+^_`{}~-]+(?:\.[a-zA-Z0-9!#$%&'+^_`{}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
            evaluate(function () {
                error = !value.match(emailRegex) ? errorMessage : null;
            });
            return this;
        },
        isNumeric: function (errorMessage) {
            evaluate(function () {
                error = !value.match(/^[0-9]+$/) ? errorMessage : null;
            });
            return this;
        },
        isLastFiveCharNumeric: function (errorMessage) {
            evaluate(function () {
                var lastFiveNumber = value.substr(3, 9);
                var length = value && value.length ? lastFiveNumber : '';
                error = !length.match(/^[0-9]+$/) ? errorMessage : null;
            }, true);
            return this;
        },
        isValidSerialNumber: function (errorMessage) {
            return this.isAlphaNumeric(errorMessage)
                .minChar(errorMessage, 3)
                .maxChar(errorMessage, 8)
                .isLastFiveCharNumeric(errorMessage);
        },
        isValidPhoneNumber: function (errorMessage) {
            evaluate(function () {
                error = !value.match(/^[0-9 +()-]*$/) ? errorMessage : null;
            });
            return this.minChar(errorMessage, 7);
        },
        isInvalidCharacter: function (errorMessage) {
            evaluate(function () {
                error = value.match(/[<>[{}\]\\/]/gi) ? errorMessage : null;
            });
            return this;
        },
        isValidRangeDates: function (errorMessage) {
            evaluate(function () {
                error =
                    value.end && value.start && compareAsc__default.default(value.start, value.end) === 1
                        ? errorMessage
                        : null;
            });
            return this;
        },
        isValidQuantity: function (stdValidation, callback) {
            evaluate(function () {
                if (callback) {
                    var callbackValue = callback(value);
                    if (!callbackValue) {
                        error = stdValidation(value);
                    }
                    else {
                        error = callbackValue;
                    }
                }
                else {
                    error = stdValidation(value);
                }
            });
            return this;
        },
        isValidBucketModelNumber: function (errorMessage) {
            evaluate(function () {
                error = !value.match(/^([0-9]){3}-([0-9]){4}$/) ? errorMessage : null;
            });
            return this;
        }
    };
    return obj;
};
var Validator$1 = Validator;

exports.default = Validator$1;
//# sourceMappingURL=Validator.js.map
